export default "__VITE_ASSET__CN3aLZvG__"